import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "px-8 pb-6" };
const _hoisted_2 = { class: "flex items-center" };
const _hoisted_3 = {
    key: 1,
    class: "space-y-4"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "flex flex-wrap items-center justify-center gap-2 text-xs text-gray-600" };
const _hoisted_6 = { class: "space-y-2" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    key: 0,
    class: "flex items-center justify-center"
};
const _hoisted_9 = {
    key: 1,
    class: "flex items-center justify-center"
};
const _hoisted_10 = {
    key: 3,
    class: "fixed inset-0 z-[210] flex items-center justify-center bg-black/60 p-4"
};
const _hoisted_11 = { class: "w-full max-w-2xl rounded-2xl bg-white shadow-2xl" };
const _hoisted_12 = { class: "flex items-center justify-between border-b border-gray-200 px-5 py-4" };
const _hoisted_13 = { class: "p-5" };
const _hoisted_14 = {
    key: 4,
    class: "space-y-4"
};
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { key: 2 };
const _hoisted_18 = { key: 3 };
const _hoisted_19 = { class: "flex flex-col sm:flex-row gap-3" };
import { ref, computed, defineAsyncComponent } from 'vue';
import { useTheme } from '@shared/composables/useTheme';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnhancedOrderSubmitButton',
    props: {
        canSubmit: { type: Boolean },
        isLoading: { type: Boolean },
        isPricingLoading: { type: Boolean },
        totalAmount: {},
        formatPrice: { type: Function },
        error: {},
        orderSuccess: { type: Boolean },
        orderNumber: {},
        paymentMethod: {},
        orderData: {},
        paymentConfig: {}
    },
    emits: ["submit", "payment-success", "payment-error", "payment-cancel"],
    setup(__props, { emit: __emit }) {
        const PayPalCheckout = defineAsyncComponent(() => import('./PayPalCheckout.vue'));
        const StripeCheckout = defineAsyncComponent(() => import('./StripeCheckout.vue'));
        const props = __props;
        const emit = __emit;
        // 🎨 Theme System
        const { theme } = useTheme();
        const showOnlineModal = ref(false);
        // Restaurant location (can be fetched from store or API if needed)
        const restaurantLocation = ref({
        // This would typically come from your restaurant settings
        // For now, leaving empty object - backend will use project's location
        });
        const calculateSubtotal = () => {
            return props.totalAmount - (props.orderData?.deliveryFee || 0) - (props.orderData?.serviceFee || 0);
        };
        // ✅ Button ist beschäftigt, wenn Bestellung verarbeitet wird
        //    ODER die Kosten gerade (neu) berechnet werden.
        const isBusy = computed(() => props.isLoading || !!props.isPricingLoading);
        const busyText = computed(() => {
            if (props.isLoading)
                return 'Bestellung wird verarbeitet...';
            if (props.isPricingLoading)
                return 'Kosten werden berechnet...';
            return '';
        });
        const isOnlinePaymentSelected = computed(() => {
            return ['paypal', 'stripe', 'online'].includes(props.paymentMethod);
        });
        const activeOnlineProvider = computed(() => {
            if (props.paymentConfig?.activeOnlineProvider === 'stripe')
                return 'stripe';
            if (props.paymentMethod === 'stripe')
                return 'stripe';
            return 'paypal';
        });
        const supportedPaymentIcons = computed(() => {
            const icons = props.paymentConfig?.supportedPaymentMethodIcons;
            if (Array.isArray(icons) && icons.length)
                return icons.slice(0, 7);
            return ['visa', 'mastercard', 'apple_pay', 'google_pay', 'klarna', 'sepa', 'paypal'];
        });
        const paymentIconLabels = {
            visa: 'VISA',
            mastercard: 'Mastercard',
            apple_pay: 'Apple Pay',
            google_pay: 'Google Pay',
            klarna: 'Klarna',
            sepa: 'SEPA',
            paypal: 'PayPal'
        };
        const onlineButtonStyle = computed(() => {
            if (!props.canSubmit || props.isLoading || props.isPricingLoading)
                return undefined;
            return {
                backgroundColor: theme.value.colors.primary,
                borderColor: theme.value.colors.primary
            };
        });
        const continueOrderStyle = computed(() => ({
            backgroundColor: theme.value.colors.primary
        }));
        const submitButtonStyle = computed(() => {
            const disabled = !props.canSubmit || isBusy.value;
            const primary = theme.value.colors.primary;
            return {
                backgroundColor: disabled ? '#9ca3af' : primary,
                borderColor: disabled ? '#9ca3af' : primary,
                borderRadius: theme.value.borderRadius,
                color: '#ffffff'
            };
        });
        const handleSubmit = () => {
            if (!props.canSubmit || props.isLoading || props.isPricingLoading)
                return;
            emit('submit');
        };
        function handlePayPalSuccess(paymentData) {
            console.log('💰 PayPal payment successful:', {
                orderID: paymentData.orderID,
                amount: paymentData.amount,
                captureID: paymentData.captureID,
                orderNumber: paymentData.orderNumber
            });
            showOnlineModal.value = false;
            emit('payment-success', paymentData); // ✅ FIX: Changed from 'paypal-success' to 'payment-success'
        }
        function handlePayPalError(error) {
            console.error('❌ PayPal payment error:', error);
            emit('payment-error', error); // ✅ FIX: Changed from 'paypal-error' to 'payment-error'
        }
        function handlePayPalCancel(data) {
            console.log('🚫 PayPal payment was cancelled by user', data);
            // ✅ FIX: Forward cancel event to parent (CheckoutPage)
            emit('payment-cancel', data);
        }
        function handleStripeSuccess(paymentData) {
            showOnlineModal.value = false;
            emit('payment-success', paymentData);
        }
        function handleStripeError(error) {
            emit('payment-error', error);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createCommentVNode(" Error State "),
                (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mb-4 p-4 border rounded-lg",
                        style: _normalizeStyle({
                            backgroundColor: _unref(theme).colors.danger + '10',
                            borderColor: _unref(theme).colors.danger + '40'
                        })
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("i", {
                                class: "fas fa-exclamation-triangle mr-2",
                                style: _normalizeStyle({ color: _unref(theme).colors.danger })
                            }, null, 4 /* STYLE */),
                            _createElementVNode("p", {
                                class: "font-medium",
                                style: _normalizeStyle({ color: _unref(theme).colors.danger })
                            }, _toDisplayString(_ctx.error), 5 /* TEXT, STYLE */)
                        ])
                    ], 4 /* STYLE */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Online Payment Section (Stripe/PayPal switch) "),
                (isOnlinePaymentSelected.value && !_ctx.orderSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "w-full rounded-xl border-2 px-6 py-4 font-semibold text-white shadow-sm transition disabled:cursor-not-allowed disabled:border-gray-400 disabled:bg-gray-400",
                            style: _normalizeStyle(onlineButtonStyle.value),
                            disabled: !_ctx.canSubmit || _ctx.isLoading || _ctx.isPricingLoading,
                            onClick: _cache[0] || (_cache[0] = ($event) => (showOnlineModal.value = true))
                        }, [
                            (_ctx.isPricingLoading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1 /* CACHED */)),
                                    _cache[3] || (_cache[3] = _createTextVNode(" Kosten werden berechnet... ", -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-credit-card mr-2" }, null, -1 /* CACHED */)),
                                    _cache[5] || (_cache[5] = _createTextVNode(" Jetzt online bezahlen ", -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                        ], 12 /* STYLE, PROPS */, _hoisted_4),
                        _createElementVNode("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportedPaymentIcons.value, (icon) => {
                                return (_openBlock(), _createElementBlock("span", {
                                    key: icon,
                                    class: "rounded bg-gray-100 px-2 py-1 font-semibold text-gray-700"
                                }, _toDisplayString(paymentIconLabels[icon] || icon), 1 /* TEXT */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]))
                    : (!_ctx.orderSuccess)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createCommentVNode(" Traditional Submit Button for Cash/Card "),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("button", {
                                    onClick: handleSubmit,
                                    disabled: !_ctx.canSubmit || isBusy.value,
                                    class: "submit-order-btn w-full text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 shadow-sm border-2 transform hover:scale-105 disabled:hover:scale-100 disabled:cursor-not-allowed",
                                    style: _normalizeStyle(submitButtonStyle.value)
                                }, [
                                    (isBusy.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(busyText.value), 1 /* TEXT */)
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-shopping-cart mr-2" }, null, -1 /* CACHED */)),
                                            _createTextVNode(" Jetzt bestellen - " + _toDisplayString(_ctx.formatPrice(_ctx.totalAmount)), 1 /* TEXT */)
                                        ]))
                                ], 12 /* STYLE, PROPS */, _hoisted_7)
                            ])
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                _createCommentVNode(" Online Payment Modal "),
                (showOnlineModal.value && isOnlinePaymentSelected.value && !_ctx.orderSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Online-Zahlung", -1 /* CACHED */)),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "text-gray-500 hover:text-gray-800",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (showOnlineModal.value = false))
                                }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */)
                                    ]))])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                (activeOnlineProvider.value === 'stripe')
                                    ? (_openBlock(), _createBlock(_unref(StripeCheckout), {
                                        key: 0,
                                        "order-data": _ctx.orderData,
                                        "cart-items": _ctx.orderData?.items || [],
                                        "delivery-type": _ctx.orderData?.orderType || 'pickup',
                                        "customer-info": _ctx.orderData?.customer,
                                        "delivery-address": _ctx.orderData?.customer?.address,
                                        "special-instructions": _ctx.orderData?.customer?.deliveryInstructions || '',
                                        onPaymentSuccess: handleStripeSuccess,
                                        onPaymentError: handleStripeError
                                    }, null, 8 /* PROPS */, ["order-data", "cart-items", "delivery-type", "customer-info", "delivery-address", "special-instructions"]))
                                    : (_openBlock(), _createBlock(_unref(PayPalCheckout), {
                                        key: 1,
                                        amount: _ctx.totalAmount.toFixed(2),
                                        currency: "EUR",
                                        "payment-config": _ctx.paymentConfig,
                                        disabled: !_ctx.canSubmit,
                                        "order-data": {
                                            ..._ctx.orderData,
                                            totalAmount: _ctx.totalAmount,
                                            orderDetails: {
                                                subtotal: calculateSubtotal(),
                                                deliveryFee: (_ctx.orderData?.deliveryFee || 0),
                                                serviceFee: (_ctx.orderData?.serviceFee || 0),
                                                total: _ctx.totalAmount
                                            }
                                        },
                                        "cart-items": _ctx.orderData?.items || [],
                                        "delivery-type": _ctx.orderData?.orderType || 'pickup',
                                        "customer-info": _ctx.orderData?.customer,
                                        "delivery-address": _ctx.orderData?.customer?.address,
                                        "special-instructions": _ctx.orderData?.customer?.deliveryInstructions || '',
                                        location: restaurantLocation.value,
                                        onPaymentSuccess: handlePayPalSuccess,
                                        onPaymentError: handlePayPalError,
                                        onPaymentCancel: handlePayPalCancel
                                    }, null, 8 /* PROPS */, ["amount", "payment-config", "disabled", "order-data", "cart-items", "delivery-type", "customer-info", "delivery-address", "special-instructions", "location"]))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Success State "),
                (_ctx.orderSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", {
                            class: "border rounded-lg p-6 text-center",
                            style: _normalizeStyle({
                                backgroundColor: _unref(theme).colors.success + '10',
                                borderColor: _unref(theme).colors.success + '40'
                            })
                        }, [
                            _createElementVNode("div", {
                                class: "text-4xl mb-3",
                                style: _normalizeStyle({ color: _unref(theme).colors.success })
                            }, [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1 /* CACHED */)
                                ]))], 4 /* STYLE */),
                            _createElementVNode("h3", {
                                class: "text-lg font-semibold mb-2",
                                style: _normalizeStyle({ color: _unref(theme).colors.success })
                            }, "Bestellung erfolgreich!", 4 /* STYLE */),
                            _createElementVNode("p", {
                                class: "mb-3",
                                style: _normalizeStyle({ color: _unref(theme).colors.success })
                            }, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "font-medium" }, "Bestellnummer:", -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_ctx.orderNumber), 1 /* TEXT */)
                            ], 4 /* STYLE */),
                            _createElementVNode("div", {
                                class: "space-y-2 text-sm",
                                style: _normalizeStyle({ color: _unref(theme).colors.success })
                            }, [
                                (_ctx.paymentMethod === 'paypal' || _ctx.paymentMethod === 'online')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [...(_cache[12] || (_cache[12] = [
                                            _createElementVNode("i", { class: "fas fa-check mr-1" }, null, -1 /* CACHED */),
                                            _createTextVNode(" Online-Zahlung erfolgreich verarbeitet ", -1 /* CACHED */)
                                        ]))]))
                                    : (_ctx.paymentMethod === 'stripe')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [...(_cache[13] || (_cache[13] = [
                                                _createElementVNode("i", { class: "fas fa-check mr-1" }, null, -1 /* CACHED */),
                                                _createTextVNode(" Stripe Zahlung erfolgreich verarbeitet ", -1 /* CACHED */)
                                            ]))]))
                                        : (_ctx.paymentMethod === 'cash')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-clock mr-1" }, null, -1 /* CACHED */)),
                                                _createTextVNode(" Zahlung bei " + _toDisplayString(_ctx.orderData?.orderType === 'delivery' ? 'Lieferung' : 'Abholung'), 1 /* TEXT */)
                                            ]))
                                            : (_ctx.paymentMethod === 'card')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-clock mr-1" }, null, -1 /* CACHED */)),
                                                    _createTextVNode(" Kartenzahlung bei " + _toDisplayString(_ctx.orderData?.orderType === 'delivery' ? 'Lieferung' : 'Abholung'), 1 /* TEXT */)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                            ], 4 /* STYLE */)
                        ], 4 /* STYLE */),
                        _createCommentVNode(" Action Buttons "),
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_router_link, {
                                to: "/",
                                class: "flex-1 bg-gray-600 hover:bg-gray-700 text-white text-center py-3 px-4 rounded-lg font-medium transition-colors"
                            }, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "fas fa-home mr-2" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Zur Startseite ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_router_link, {
                                to: "/menu",
                                class: "flex-1 text-white text-center py-3 px-4 rounded-lg font-medium transition-colors",
                                style: _normalizeStyle(continueOrderStyle.value)
                            }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("i", { class: "fas fa-utensils mr-2" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Weiter bestellen ", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["style"])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
